import React from 'react'
import pageStyle from './page.module.css'
import { useNavigate } from 'react-router-dom'

const ComingSoon = () => {
    const nav = useNavigate()
    return (
        <div className={pageStyle.mainContainer}>
            <div className={pageStyle.leftSideContent}>
                <div className={pageStyle.error404}>
                    
                </div>
                <h1 className={pageStyle.oopPageNotFound}>
                  Coming Soon
                </h1>
                <p className={pageStyle.description}>
                Exciting features are on their way! Stay tuned as we work hard to bring you
                something amazing. Check back later for updates.                </p>
                <div className={pageStyle.goBackButton}  onClick={() => nav('/courses/Courses')}>
                    <p>Go Back</p>
                </div>
            </div>
            <div className={pageStyle.rightSideContent}>
                <img src='/comingsoon.jpg' alt='coming soon'width="60%"/>
            </div>
        </div>
    )
}

export default ComingSoon;